import type { UseQueryResult } from '@tanstack/react-query'

import type { PricePrefillBidsResponse } from '@/features/bidding/endpoints/pricePrefillBids'
import type { BidsLatestPricesQueryParams } from '@/features/bidding/hooks/usePricePrefillBidsQuery'
import { usePricePrefillBidsQuery } from '@/features/bidding/hooks/usePricePrefillBidsQuery'
import type { UseQueryOptions } from '@/types/queries'

export type { BidsLatestPricesQueryParams } from '@/features/bidding/hooks/usePricePrefillBidsQuery'

export type UseBidsLatestPricesPerGroupQueryResult = Omit<UseQueryResult, 'data'> & {
  prices: Map<string, number[]>
}

export const useBidsLatestPricesPerGroupQuery = (
  params: BidsLatestPricesQueryParams,
  options?: UseQueryOptions<PricePrefillBidsResponse>,
): UseBidsLatestPricesPerGroupQueryResult => {
  const { data, ...queryResult } = usePricePrefillBidsQuery(params, options)

  if (!data) {
    return { prices: new Map(), ...queryResult }
  }

  const prices = new Map(
    Object.entries(data).map(([activationGroupUuid, prefillBid]) => [activationGroupUuid, prefillBid.offeredPrices]),
  )
  return { prices, ...queryResult }
}
